var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteBlack1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8595 13.6305C2.46815 13.6305 2.13389 13.4971 1.85673 13.2304C1.57955 12.9636 1.44097 12.6419 1.44097 12.2653V2.67979H0.65625V1.54698H4.18745V0.878906H8.89575V1.54698H12.427V2.67979H11.6422V12.2653C11.6422 12.6468 11.5049 12.9697 11.2303 13.234C10.9556 13.4983 10.6201 13.6305 10.2237 13.6305H2.8595ZM10.4652 2.67979H2.61802V12.2653C2.61802 12.3331 2.64066 12.3887 2.68594 12.4323C2.73122 12.4759 2.78907 12.4977 2.8595 12.4977H10.2237C10.2841 12.4977 10.3394 12.4735 10.3897 12.4251C10.44 12.3766 10.4652 12.3234 10.4652 12.2653V2.67979ZM4.50438 10.9872H5.68143V4.19024H4.50438V10.9872ZM7.40177 10.9872H8.57882V4.19024H7.40177V10.9872Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBlack1);
export default __webpack_public_path__ + "static/media/deleteBlack1.0d6465ea2d9505ce04452aa904f148db.svg";
export { ForwardRef as ReactComponent };